import Splide from '@splidejs/splide'

declare global {
    interface Window {
        Splide: any
    }
}

window.Splide = Splide
